import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle, statusColor } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { IllustrativeBanner } from "@/components/Disclaimers";

const money = (n) => "$" + (Math.round(n || 0)).toLocaleString();

export default function Commissions() {
  const [commissions, setCommissions] = useState([]);
  useEffect(() => { api.get("/agent/commissions").then((r) => setCommissions(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageTitle title="My Commissions" subtitle="Track potential, approved, and paid commissions" />
      <IllustrativeBanner className="mb-6" />
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="commissions-table">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr>{["Provider", "Service", "Potential", "Amount", "Status"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {commissions.map((c) => (
                <tr key={c.id} className="hover:bg-slate-50" data-testid={`commission-row-${c.id}`}>
                  <td className="px-4 py-3 font-medium text-navy">{c.provider || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{c.service_category || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{money(c.potential_amount)}</td>
                  <td className="px-4 py-3 font-semibold text-emeraldbrand">{money(c.amount)}</td>
                  <td className="px-4 py-3"><Badge className={`${statusColor(c.status)} hover:${statusColor(c.status)}`}>{(c.status || "").replace(/_/g, " ")}</Badge></td>
                </tr>
              ))}
              {commissions.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No commissions yet. Commissions follow verified placements and admin approval.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
      <Card className="mt-6 p-6">
        <h3 className="font-heading text-base font-semibold text-navy">Commission workflow</h3>
        <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
          {["Service Start", "Verify Provider Agreement", "Verify Agent Agreement", "Verify Private-Pay", "Verify Payment", "Commission Review", "Admin Approval", "Approved", "Paid"].map((s, i) => (
            <React.Fragment key={s}>
              <span className="rounded-full bg-slate-100 px-3 py-1 font-medium text-slate-600">{s}</span>
              {i < 8 && <span className="text-slate-300">→</span>}
            </React.Fragment>
          ))}
        </div>
        <p className="mt-4 text-sm text-slate-500">Placement complete does not automatically mean commission paid. Every step is recorded in an audit history.</p>
      </Card>
    </div>
  );
}
